import OBJECT_TYPE_VIEW_ENUM from '../../constants/OBJECT_TYPE_VIEW_ENUM';
import { NDFL3DefaultLogic } from './NDFL3DefaultLogic';
import { isIncomeSaleRealEstateOrShare } from './NDFL3YearsLogic';

class NDFL3YearLogic2017 extends NDFL3DefaultLogic {
  name() {
    return '2017';
  }

  /**
   * Видимость полей Сумма расходов на прохождение независимой оценки своей квалификации
   *  и пункта в списке 'Социальные налоговые вычеты' на шаге 'Выбор вычетов'
   *
   * @returns {boolean}
   */
  isVisibleAssessmentQualifications() {
    return true;
  }

  /**
   * Видимость компонента с адресом на шаге Имущественный вычет
   *
   * @param {string} objectTypeView
   * @param {boolean} noAddress
   * @returns {boolean}
   */
  isVisibleAddressDeductionForYear(objectTypeView, noAddress) {
    return objectTypeView === OBJECT_TYPE_VIEW_ENUM.NO_NUMBER && noAddress !== true;
  }

  /**
   * Видимость полей Остаток вычета, перешедший с предыдущего периода и процентам на шаге Имущественный вычет
   *
   * @returns {boolean}
   */
  isVisibleRemainderDeductionPreviousPeriodForYear() {
    return false;
  }

  /**
   * Видимость полей:
   *  Вид номера объекта
   *  Номер объекта
   *  У объекта нет официально присвоенного адреса
   *  Сведения о местонахождении объекта
   *  на шаге Имущественный вычет
   *
   * @returns {boolean}
   */
  isVisibleNumberAndViewObjectForYear() {
    return true;
  }

  /**
   * Изменять ли состояние в зависимости от года на шаге Имущественный вычет
   */
  isDispatchPropertyDeductionFieldsForYear() {
    return true;
  }

  showObjectAddress() {
    return true;
  }

  getLabelForCharityLiveDeductionSelected() {
    return 'Вычет по расходам на обучение, лечение, благотворительность, оценку квалификации';
  }

  isVisibleAdditionalFieldsForYear() {
    return true;
  }

  /**
   * Disable поля incomeSum + расчет на шаге 'Доходы'
   * @param {number|string} year
   * @param {number} incomeCode
   * @returns {boolean|*}
   */
  isIncomeSumForYear(year, incomeCode) {
    return isIncomeSaleRealEstateOrShare(incomeCode);
  }

  getSalaryIncomeTypeCodes13() {
    return [2000, 2001, 2002, 2003, 2010, 2012, 2013, 2014, 2300, 2301, 2530];
  }

  getSalaryIncomeTypeCodes30() {
    return [1010];
  }

  showDrugsExpenses() {
    return false;
  }

  isVisibleSoldObjectPurchasedAfter(code) {
    return [1510, 1511, 1512].includes(code);
  }
}

export default NDFL3YearLogic2017;
